
import Home from './pages/Home'

const About = () => import('./pages/About')
const Faq = () => import('./pages/Faq')
const TermsAndConditions = () => import('./pages/TermsAndConditions')

export default [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      accessAnyWhere: true,
    },
  },
  {
    path: '/about-us',
    name: 'About',
    component: About,
    meta: {
      accessAnyWhere: true,
      title: 'About Us',
    },
  },
  {
    path: '/faq',
    name: 'Faq',
    component: Faq,
    meta: {
      accessAnyWhere: true,
      title: 'FAQ',
    },
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
    meta: {
      accessAnyWhere: true,
      title: 'Terms and Conditions',
    },
  },
]
